import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Field } from '../../../environments/field';
import { apis} from '../../../environments/apis';
import { environment} from '../../../environments/environment';
import { view_seccion } from '../../../environments/seccions';
// import { UserService } from '../../services/user.service';
import { CrudService } from '../../../environments/crud.service';
import { setForm } from '../../../environments/set_form';
import { from } from 'rxjs';

// Aqui importa los formularios
import * as forms from './forms';
// Tabla
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
// Moneda en input
import { CommonModule, CurrencyPipe} from '@angular/common';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
// import { NotificationsService, NotificationType } from 'angular2-notifications';



@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls:['./form.component.css'],
  providers: [CrudService, CurrencyPipe],
})
export class FormComponent implements OnInit {
  // windowWidth = window.innerWidth - 330
  // scrollBarHorizontal = (window.innerWidth < 1200);
  tipo_de_usuario = sessionStorage.getItem('tipo_de_usuario')
  @Input() is_tab = false;
  public modalRef: BsModalRef;
  public url = environment.apiUrl;
  public data_negocio = {
    color_secundario:"#FFFFFF"
  };
  public token;
  public calificacion;
  public idmodal;
  public id;
  public areas = false;
  public saved = false;

  public seccion: string;
  public view_seccion: string;

  //Con areas
  public con_areas = {
    // Planeacion e informacion
    categorias:[
      {nombre:'Conceptos', url:'categorias', principal:true, visible:true, atras:"categorias"},
      {nombre:'Evaluar', url:'sub_categorias', principal:true, visible:true, atras:"categorias/editar/", tabla:true},
    ],
    // preguntas:[
    //   {nombre:'Preguntas', url:'preguntas', principal:true, visible:true, atras:"encuestas/editar/"},
    //   {nombre:'Opciones', url:'opciones', principal:false, visible:false, atras:"encuestas/editar/", tabla:true},
    // ],
    oficinas_de_ventas:[
      {nombre:'Oficinas de ventas', url:'oficinas_de_ventas', principal:true, visible:true, atras:"oficinas_de_ventas"},
      {nombre:'Areas de ventas', url:'areas_de_ventas', principal:false, visible:false, atras:"oficinas_de_ventas/editar/", tabla:true},
    ],
  }
  public list_areas = []

  public alumnos:Array<any> = [];
  public urls:Array<string>
  public agregar_editar:string
  public href: Array<any> = [];
  public preview:boolean = false;
  public vistaprevia:{
    color_tablas:string,
    color_encabezados:string,
    cliente:string,
    producto:string,
    cantidad:string,
    unidad:string,
    fecha_de_pedido:string,
    fecha_de_expedicion:string,
    fecha_de_iniciacion:string,
    fecha_de_entrega:string,
    materia_prima_directa_unitario:string,
    materia_prima_directa_total:string,
    mano_de_obra_directa_unitario:string,
    mano_de_obra_directa_total:string,
    costo_primo_unitario:string,
    costo_primo_total:string,
    cargos_indirectos_unitarios:string,
    cargos_indirectos_totales:string,
    costos_de_produccion_unitarios:string,
    costos_de_produccion_totales:string,
    costos_de_presupuestados:string,
    costos_reales:string,
    diferencia:string,
    responsable_de_produccion:string,
    observaciones:string,
  };
  public vistapreviaprocesos:[{
    nombre:string,
    imagen:string,
    descripcion:string,
    proceso:[string],
    materia_prima_compartida:[string],
    materia_prima_no_compartida:[string],
    mano_de_obra:[string],
    cargos_indirectos:[string],
    
  }];
  public producto_terminado:{
    imagen:string,
    descripcion:string,    
    
  };

  public proyecto = sessionStorage.getItem('proyecto'); 
  public tipo_de_area = sessionStorage.getItem('tipo_de_area'); 


  // private _userService: UserService,
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private crud:CrudService,
    private modalService: BsModalService,
    // private notifications: NotificationsService,
  ) {
    this.token = sessionStorage.getItem("token");
  }

  ngOnInit(): void {
    // if (this.scrollBarHorizontal) {
    //   this.windowWidth = window.innerWidth - 50
    // }
    // if(this.is_tab){
    //   alert()
    //   this.windowWidth = window.innerWidth - 50

    // }
    this.data_negocio = JSON.parse(sessionStorage.getItem('negocio_data'))
    this.route.params.subscribe((params) => {
      this.href = this.router.url.split("/");
      if(this.href[3] == "preview"){
        this.preview = true;
      }
      if(params.seccion in this.con_areas){
        
        localStorage.removeItem('atras')
  
      }
      this.seccion = params.seccion;
      this.view_seccion = view_seccion[params.seccion];
      this.id = params.id ? params.id : params.slug;
      this.urls = this.router.url.split('/')
      this.agregar_editar = this.urls[this.urls.length - 1]
      
      if(this.seccion in this.con_areas){
        this.areas = true;
        this.list_areas = this.con_areas[this.seccion];

      }
      if(this.id){
        this.saved = true;
      }
      
      if(this.seccion == "grupos"){
        this.crud.getData('alumnos', this.token, {id:this.id}).subscribe(
          response => {
            this.alumnos = response.data
            // this.alumnos = response.data
          }
        )
        
      }
      else if (this.seccion == "hoja_de_costo_por_ordenes" && this.preview){
        this.crud.getData('hojas_de_costos_por_ordenes/'+this.id, this.token, {is_preview:true, proyecto:this.proyecto}).subscribe(
          response => {
            this.vistaprevia = response.data
            // this.alumnos = response.data
          }
        )

      }
      else if (this.seccion == "procesos" && this.preview){
        this.crud.getData('procesos_data', this.token, {is_preview:true, proyecto:this.proyecto, id:this.id}).subscribe(
          response => {
            this.vistapreviaprocesos = response.data
            this.producto_terminado = response.producto_terminado
          }
        )

      }
      
    });

  }

  changeSave(){
    this.saved = true;
  }
  changeId(id){
    console.log(id)
    this.id = id;
  }

  showTab(select_area){
    for (let area of this.list_areas){
      if (select_area == area.url){
        area.visible = true;
      }
      else{
        area.visible = false;

      }

    } 
  }

  openModal(template: TemplateRef<any>, id) {
    this.idmodal = id;
    this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
  }

  removeByAttr(arr, attr, value){
    var i = arr.length;
    while(i--){
      if( arr[i]
        && arr[i].hasOwnProperty(attr)
        && (arguments.length > 2 && arr[i][attr] === value ) ){

        arr.splice(i,1);

      }
    }
    return arr;
  }

  confirmEliminar(): void {

    this.crud.deleteData(this.token, 'gruposalumnos', this.idmodal).subscribe(
      response => {
        // this.notifications.create('¡Genial!', "Ha sido eliminado correctamente", NotificationType.Bare, { theClass: 'outline primary', timeOut: 6000, showProgressBar: false });
        this.removeByAttr(this.alumnos, 'id', this.idmodal);
        this.alumnos = [... this.alumnos];
      }
    )

    this.modalRef.hide();
  }
  
  confirmActivar(): void {

    this.crud.putData('gruposalumnos/'+this.idmodal, this.token, {validado:true}).subscribe(
      response => {
        // this.notifications.create('¡Genial!', "Ha sido activado correctamente", NotificationType.Bare, { theClass: 'outline primary', timeOut: 6000, showProgressBar: false });
        for(let alumno of this.alumnos){
          if(alumno['id'] == this.idmodal){
            alumno['validacion'] = true
          }
        }
      }
    )

    this.modalRef.hide();
  }

  confirmDesactivar(): void {

    this.crud.putData('gruposalumnos/'+this.idmodal, this.token, {validado:false}).subscribe(
      response => {
        // this.notifications.create('¡Genial!', "Ha sido desactivado correctamente", NotificationType.Bare, { theClass: 'outline primary', timeOut: 6000, showProgressBar: false });
        for(let alumno of this.alumnos){
          if(alumno['id'] == this.idmodal){
            alumno['validacion'] = false
          }
        }
      }
    )

    this.modalRef.hide();
  }
  
  confirmCalificacion(): void {

    this.crud.putData('gruposalumnos/'+this.idmodal, this.token, {validado:false, calificacion:this.calificacion}).subscribe(
      response => {
        // this.notifications.create('¡Genial!', "Ha sido eliminado correctamente", NotificationType.Bare, { theClass: 'outline primary', timeOut: 6000, showProgressBar: false });
        for(let alumno of this.alumnos){
          if(alumno['id'] == this.idmodal){
            alumno['calificacion'] = this.calificacion
          }
        }
      }
    )

    this.modalRef.hide();
  }

  decline(): void {
    // this.message = 'Declined!';
    this.modalRef.hide();
  }
}